import React from 'react';
import {UserApp} from '../../../../Context/AuthProvider/AuthProviderActions';
import {Button, Col, Form, Row, Select} from 'antd';
import {DiazarFormInput} from '../../../../Components/Form/DiazarFormInput';
import {getNewUser} from '../../../../Actions/Users/UsersActions';

interface ViewProps {
    user: UserApp,
    keys: number[],
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
    saveDiazarUserFunc: (updateUser: UserApp) => void,
    setUser: React.Dispatch<React.SetStateAction<UserApp>>,
    disableAll: boolean
}

export const UserBaseForm: React.FunctionComponent<ViewProps> = (props) => {
    const {user, keys, setIsLoading, saveDiazarUserFunc, setUser, disableAll} = props;
    const [resetForm, setResetForm] = React.useState<boolean>(false);

    const [clave, setClave] = React.useState<string>('');
    const [isValidClave, setIsValidClave] = React.useState<boolean>(false);

    const [llave, setllave] = React.useState<number>();
    const [isValidLlave, setIsValidLlave] = React.useState<boolean>(false);

    const [nombres, setNombres] = React.useState<string>('');
    const [isValidNombres, setIsValidNombres] = React.useState<boolean>(false);

    const [apellidos, setApellidos] = React.useState<string>('');
    const [isValidApellidos, setIsValidApellidos] = React.useState<boolean>(false);

    const [email, setEmail] = React.useState<string>('');
    const [isValidEmail, setIsValidEmail] = React.useState<boolean>(false);

    const [telephone, setTelephone] = React.useState<string>();
    const [isValidTelephone, setIsValidTelephone] = React.useState<boolean>(false);


    const OPTIONS = React.useMemo(() => {
        const kaysToShow: number[] = keys;
        if (user.ids > 0) {
            if (kaysToShow.indexOf(user.ids) === -1) {
                kaysToShow.push(user.ids);

                kaysToShow.sort(function (a, b) {
                    return a - b;
                });
            }
        }


        const opts = kaysToShow.map(k => {
            return {value: k, label: k.toString()};
        });

        return opts;
    }, [keys, user.ids]);

    React.useEffect(() => {
        setResetForm(true);

        setClave(user.clave);

        if (user.ids > 0) {
            setllave(user.ids);
        } else {
            if (OPTIONS.length > 0) {
                setllave(OPTIONS[0].value);
            } else {
                setllave(undefined);
            }
        }

        setNombres(user.first_name);
        setApellidos(user.last_name);
        setEmail(user.email);
        setTelephone(user.telephone);


        setTimeout(() => {
            setResetForm(true);
        }, 150);
    }, [OPTIONS, user]);

    React.useEffect(() => {
        setIsValidLlave(llave !== undefined && llave > 0 && (llave === user.ids || keys.indexOf(llave) !== -1));
    }, [keys, llave, user.ids]);

    const isValidForm = React.useMemo(() => {
        const isValid = isValidClave && isValidLlave &&
            isValidNombres && isValidApellidos &&
            isValidEmail && isValidTelephone;

        if (isValid) {
            return (
                clave !== user.clave ||
                llave !== user.ids ||
                nombres !== user.first_name ||
                apellidos !== user.last_name ||
                email !== user.email ||
                telephone !== user.telephone
            );
        }

        return isValid;
    }, [apellidos, clave, email, isValidApellidos, isValidClave, isValidEmail, isValidLlave, isValidNombres, isValidTelephone, llave, nombres, telephone, user.clave, user.email, user.first_name, user.ids, user.last_name, user.telephone]);


    const saveUserHandler = React.useCallback(() => {
        if (!isValidForm) return;

        const ids = llave !== undefined ? llave : 0;
        const updateUser: UserApp = {
            ...user,
            clave: clave,
            ids: ids,
            first_name: nombres,
            last_name: apellidos,
            email: email,
            telephone: telephone
        };

        saveDiazarUserFunc(updateUser);

    }, [apellidos, clave, email, isValidForm, llave, nombres, saveDiazarUserFunc, telephone, user]);

    const cancelHandler = React.useCallback(() => {
        if (user.id === 0) {
            setUser(getNewUser());
        }

        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 300);


    }, [setIsLoading, setUser, user.id]);


    if (!resetForm) {
        return null;
    }

    return (
        <Form layout="horizontal" labelCol={{span: 8}} wrapperCol={{span: 16}}>
            <Row gutter={20}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                    <DiazarFormInput id={'user-clave'}
                                     label={'Clave'}
                                     initialValue={clave}
                                     isRequired={true}
                                     getState={(isValid, value) => {
                                         setIsValidClave(isValid);
                                         setClave(value);
                                     }}
                                     isReadOnly={ disableAll }
                    />
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                    <Form.Item name="keys"
                               label="Llave"
                               rules={[
                                   {
                                       required: true,
                                       message: 'Debes seleccionar una llave para desbloquear al usuario'
                                   }
                               ]}
                               initialValue={llave}
                    >
                        <Select
                            showSearch
                            placeholder="Selecione una llave"
                            onChange={(value) => {
                                setllave(value);
                            }}
                            allowClear
                            options={OPTIONS}
                            value={llave}
                            aria-errormessage={'Por favor seleccione una llave'}
                            disabled={ disableAll }
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={20}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                    <DiazarFormInput id={'user-nombres'}
                                     label={'Nombre(s)'}
                                     initialValue={nombres}
                                     isRequired={true}
                                     getState={(isValid, value) => {
                                         setIsValidNombres(isValid);
                                         setNombres(value);
                                     }}
                                     isReadOnly={ disableAll }
                    />
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                    <DiazarFormInput id={'user-apellidos'}
                                     label={'Apellidos(s)'}
                                     initialValue={apellidos}
                                     isRequired={true}
                                     getState={(isValid, value) => {
                                         setIsValidApellidos(isValid);
                                         setApellidos(value);
                                     }}
                                     isReadOnly={ disableAll }
                    />
                </Col>
            </Row>

            <Row gutter={20}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                    <DiazarFormInput id={'user-email'}
                                     label={'Email'}
                                     initialValue={email}
                                     isRequired={true}
                                     getState={(isValid, value) => {
                                         setIsValidEmail(isValid);
                                         setEmail(value);
                                     }}
                                     type={'email'}
                                     isReadOnly={disableAll || user.id > 0}
                    />
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                    <DiazarFormInput id={'user-apellidos'}
                                     label={'Teléfono'}
                                     initialValue={telephone}
                                     getState={(isValid, value) => {
                                         setIsValidTelephone(isValid);
                                         setTelephone(value);
                                     }}
                                     type="tel"
                                     isReadOnly={disableAll}
                    />
                </Col>
            </Row>

            <Row gutter={20} style={{marginTop: 10}}>
                <Col xs={{ span: 24, offset: 0 }}
                     sm={{ span: 12, offset: 0 }}
                     md={{ span: 8, offset: 8 }}
                     lg={{ span: 6, offset: 12 }}
                     xl={{ span: 4, offset: 16 }}
                     style={{marginTop: 10}}
                >
                    <Button type="primary"
                            onClick={cancelHandler}
                            disabled={disableAll}
                            danger block
                    >
                        Cancelar
                    </Button>
                </Col>
                <Col xs={{ span: 24 }}
                     sm={{ span: 12 }}
                     md={{ span: 8 }}
                     lg={{ span: 6 }}
                     xl={{ span: 4 }}
                     style={{marginTop: 10}}
                >
                    <Button type="primary"
                            disabled={disableAll || !isValidForm}
                            onClick={saveUserHandler}
                            block
                    >
                        Enviar
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};
